<template>
  <div>
    <router-view :is_vod_event="isVodEvent"></router-view>
  </div>
</template>
<script>
export default {
  name: "ScreenerRoot",
  computed: {
    isVodEvent() {
      return this.$route.query && this.$route.query.isVodEvent ? true : false
    }
  }
}
</script>
